<template>
  <vue-editor
    ref="editor"
    :editorOptions="editorOptions"
    :value="value"
    @input="value => $emit('input', value)"
    v-bind="$attrs"
  />
</template>

<script>
import Vue from 'vue';
import { VueEditor, Quill } from 'vue2-editor';
import HMVueEditorAddImageModal from '@/web/components/common/HMVueEditorAddImageModal.vue';

const toolbar = [
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
  ['link', 'image'],
  //['showHtml']
];

export default Vue.extend({
  name: 'HMVueEditor',
  components: { VueEditor },
  props: {
    value: {
      type: String,
    },
    customToolbar: {
      type: Object,
      default: null,
    },
    pasteImageDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: {
            container: this.customToolbar ?? toolbar,
            handlers: {
              image: this.imageHandler,
              showHtml: this.htmlHandler,
            },
          },
        },
      },
      content: '',
      rawContent: '',
    };
  },
  methods: {
    imageHandler() {
      const quill = this.$refs['editor'].quill;
      const range = quill.getSelection();

      this.$modal.show(
        HMVueEditorAddImageModal,
        {},
        {},
        { selectImageUrl: url => this.embedImage(url, range) }
      );
    },
    htmlHandler() {
      if (this.txtArea.style.display === '') {
        const html = this.txtArea.value;
        if (html === '<p><br/></p>') {
          this.html = null;
        } else {
          this.html = html.replace(new RegExp('<p><br/>', 'g'), '<p>');
        }
        this.quill.pasteHTML(html);
      }
      this.txtArea.style.display =
        this.txtArea.style.display === 'none' ? '' : 'none';
    },
    embedImage(url, range) {
      const quill = this.$refs['editor'].quill;

      if (url) {
        quill.insertEmbed(range.index, 'image', url, Quill.sources.USER);
      }
    },
  },
  mounted() {
    this.quill = this.$refs.editor.quill;
    this.txtArea = document.createElement('textarea');
    this.txtArea.style.cssText =
      'width: 100%;margin: 0px;background: rgb(29, 29, 29);box-sizing: border-box;color: rgb(204, 204, 204);font-size: 15px;outline: none;padding: 20px;line-height: 24px;font-family: Consolas, Menlo, Monaco, &quot;Courier New&quot;, monospace;position: absolute;top: 0;bottom: 0;border: none;display:none;resize: none;';

    if (this.pasteImageDisabled) {
      this.quill.clipboard.addMatcher('IMG', (node, delta) => {
        const Delta = Quill.import('delta');
        return new Delta().insert('');
      });
      this.quill.clipboard.addMatcher('PICTURE', (node, delta) => {
        const Delta = Quill.import('delta');
        return new Delta().insert('');
      });
    }

    const htmlEditor = this.quill.addContainer('ql-custom');
    htmlEditor.appendChild(this.txtArea);

    this.quill.on('text-change', (delta, oldDelta, source) => {
      const html = this.quill.getHTML();
      this.txtArea.value = html;
    });
    this.content = this.value;
  },
  watch: {
    content() {
      this.rawContent = this.content;
    },
    rawContent() {
      this.content = this.rawContent;
    },
  },
});
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';

.ql-showHtml:after {
  content: '\f1c9';
  font-family: 'Font Awesome 5 Pro';
}
button.ql-showHtml {
  width: 100% !important;
}

#hm-vue-email-editor {
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  blockquote,
  pre {
    font-family: 'Poppins', Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #434245;
  }
  h1 {
    font-size: 2em;
    font-weight: bold;
  }
  h2 {
    font-size: 1.5em;
    font-weight: bold;
  }
  h3 {
    font-size: 1.17em;
    font-weight: bold;
  }
  h4 {
    font-weight: bold;
  }
  h5 {
    font-size: 0.83em;
    font-weight: bold;
  }
  h6 {
    font-size: 0.67em;
    font-weight: bold;
  }
  a {
    color: $coral;
  }
}
</style>
